{{#if label}}
  <label for="{{id}}" class="{{label_class}}">{{t label}}</label>
{{/if}}
{{#if (equal helptext.position 'top')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}
{{#if subtract_button}}<button id="decreaseButton-{{id}}" type="button" class="decrease_num" aria-label="{{t 'input.number.decreaseBtn'}}">{{subtract_button}}</button>{{/if}}
{{#if prefix_parameter}}<span class="prefix_parameter">{{t prefix_parameter}}</span>{{/if}}
<input type="number" id="{{id}}" class="{{class}}" value="{{value}}" max="{{max_value}}" min="{{min_value}}"{{#if attributes}}data-attributable{{/if}}/>
{{#if postfix_parameter}}<span class="postfix_parameter">{{t postfix_parameter}}</span>{{/if}}
{{#if add_button}}<button id="increaseButton-{{id}}" type="button" class="increase_num" aria-label="{{t 'input.number.increaseBtn'}}">{{add_button}}</button>{{/if}}
{{#if (equal helptext.position 'bottom')}}
  <p class="helptext"><small>{{t helptext.text}}</small></p>
{{/if}}
